import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/expenses'

const expensesEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchExpenses: builder.query<any, { pageNumber?: number }>({
    query: ({ pageNumber = 0 } = {}) => ({
      url: `${basePath}?size=10&page=${pageNumber}`,
      method: 'get',
    }),
    providesTags: ['expenses'],
  }),

  createExpense: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['expenses'],
  }),

  updateExpense: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['expenses'],
  }),

  deleteExpense: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['expenses'],
  }),
})

export default expensesEndpoints
